import {
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  sendPasswordResetEmail,
} from 'firebase/auth';

import {
  saveUser,
  getUserByUid,
}
from '../utils/firebaseService';

import { auth } from '../config/firebase';


const provider = new GoogleAuthProvider();

export const loginWithGoogle = async () => {
  const result =

  await signInWithPopup(
    auth,
    provider
);

console.log(
  'LOGIN GOOGLE EXECUTADO'
);

console.log(result.user);

// CRÍTICO: saveUser DEVE funcionar
// Se falhar, usuário não pode ficar autenticado
try {
  await saveUser(result.user);
} catch (error) {
  console.error('Falha crítica ao salvar usuário após Google login:', error);
  // Falha ao criar documento = autenticação inválida
  await signOut(auth);
  throw new Error('Falha ao inicializar conta. Tente novamente.');
}

await result.user.reload();
const userData =
  await getUserByUid(
    result.user.uid
  );

if (
  userData?.accountStatus ===
  'blocked'
) {

  return result;
}

console.log(
  'saveUser executado'
);

return result;
  
};


export const registerWithEmail = async (
  email: string,
  password: string
) => {
  const userCredential =
  await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );

// CRÍTICO: saveUser DEVE funcionar
// Se falhar, usuário não pode ficar autenticado
try {
  await saveUser(userCredential.user);
} catch (error) {
  console.error('Falha crítica ao salvar usuário após registro:', error);
  // Falha ao criar documento = registro inválido
  await signOut(auth);
  throw new Error('Falha ao criar conta. Tente novamente.');
}

await sendEmailVerification(
  userCredential.user
);

return userCredential;
};

export const loginWithEmail = async (
  email: string,
  password: string
) => {

  const userCredential =
    await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user =
  userCredential.user;

await user.reload();

if (!user.emailVerified) {

  await signOut(auth);

  throw new Error(
  'EMAIL_NOT_VERIFIED'
  );
}

// CRÍTICO: saveUser DEVE funcionar
// Se falhar, usuário não pode ficar autenticado
try {
  await saveUser(user);
} catch (error) {
  console.error('Falha crítica ao salvar usuário após email login:', error);
  // Falha ao criar documento = autenticação inválida
  await signOut(auth);
  throw new Error('Falha ao inicializar conta. Tente novamente.');
}

await user.reload();
const userData =
  await getUserByUid(
    user.uid
  );

if (
  userData?.accountStatus ===
  'blocked'
) {

  return userCredential;
}

console.log(
  'saveUser executado'
);
  return userCredential;
};

export const requestPasswordReset = async (email: string) => {
  await sendPasswordResetEmail(auth, email.trim());
};


export const logout = async () => {
  return await signOut(auth);
};
